<template>
  <v-card outlined class="advert-modal-container">
    <v-container>
      <v-card class="mx-auto preview-card" outlined color="transparent">
        <v-img height="100" :src="this.backgroundPreviewUrl"></v-img>
        <v-row class="preview-overlay">
          <v-list-item>
            <Avatar
              :displayName="displayName"
              :src="src"
              :size="size"
              color="color"
            />

            <v-list-item-content class="ml-2">
              <v-list-item-title class="title">
                {{ businessName }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ profileCategory }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-row>
      </v-card>
      <v-row class="mt-3 form-row">
        <v-col cols="12">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-row align="center" class="mr-0">
              <v-col cols="12" sm="6">
                <v-text-field
                  name="title"
                  v-model="title"
                  label="Public Display name"
                  prepend-icon="mdi-label"
                  :rules="titleRule"
                  required
                  @change="checkDuplicate"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="slug"
                  label="Public Profile URL"
                  prepend-icon="mdi-earth"
                  :rules="[checkSlug]"
                  required
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-text-field
                  name="link"
                  v-model="link"
                  label="Web address"
                  prepend-icon="mdi-bookmark"
                  :rules="urlRule"
                  placeholder="https://www.example.com"
                  required
                  @click="addProtocol"
                >
                  <template slot="append-outer">
                    <v-icon title="Paste from clipboard" @click="onPaste"
                      >mdi-content-paste</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <CategoryOptions
                  :switch="false"
                  :item="{
                    categoryTitle: this.category ? this.category : []
                  }"
                  v-on:modifyCategory="modifyCategory"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-file-input
                  label="Upload Logo"
                  prepend-icon="mdi-camera"
                  @change="onLogoFile"
                  accept="image/png"
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="6">
                <v-file-input
                  label="Upload background image"
                  prepend-icon="mdi-camera"
                  @change="onBackgroundFile"
                  accept="image/png"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <DescriptionComponent
                  :description="description"
                  @input="updateDescription"
                  @validate="descriptionIsValid"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <v-divider class="my-3"></v-divider>
      <p v-if="feedback" class="my-3 red--text center">{{ feedback }}</p>

      <v-btn
        v-if="!editAdvert"
        class="ma-2"
        outlined
        color="secondary"
        @click="closeModal"
      >
        Cancel
      </v-btn>
      <v-btn class="ma-2" color="primary" @click="submit">
        {{ this.editAdvert ? 'Update' : 'Create' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import firebase from 'firebase'
import db from '../../firebase/init'
const advertisers = db
  .collection('advertisers')
  .doc('starter')
  .collection('adverts')
import api from '../../api'
import CategoryOptions from '../forms/CategoryOptions.vue'
import { mapActions, mapGetters } from 'vuex'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Avatar from '../../components/layout/Avatar'
import DescriptionComponent from '../forms/DescriptionComponent.vue'

export default {
  name: 'AdvertModal',
  props: ['modal', 'editAdvert'],
  data: () => ({
    advert: {},
    valid: false,
    isValidDescription: false,
    businessNameMatch: false,
    logoPlaceholder: '/img/placeholder.jpg',
    backgroundPlaceholder: '/img/banner/networking.jpg',
    uid: firebase.auth().currentUser?.uid,
    backgroundUrl: null,
    backgroundFilename: null,
    backgroundPreviewUrl: '/img/banner/networking.jpg',
    logoUrl: null,
    logoFilename: null,
    logoPreviewUrl: '/img/placeholder.jpg',
    category: [],
    title: null,
    description: '',
    link: null,
    feedback: null,
    displayName: null,
    src: null,
    size: 50,
    color: 'primary',
    slugValue: null,
    titleRule: [
      v => !!v || 'Title is required',
      v =>
        (v && v.length <= 100) ||
        'Maximum character count of 100 has been exceeded',
      v =>
        /^[A-Za-z-.'1-9 ]+$/.test(v) ||
        'Special characters are not valid. (only apostrophes and hyphens are accepted)'
    ],

    urlRule: [
      v => !!v || 'Web site is required',
      v =>
        api.is_url(v) ||
        'Invalid URL use e.g. https://www.example.com or https://example.com'
    ]
    //checkName: [v => (v && this.checkSlug()) || 'Exist']
  }),
  created() {
    this.fetchCategories()
    if (this.editAdvert) {
      this.getAdvert()
    }
  },
  mounted() {
    if (this.advert && this.editAdvert) {
      this.title = this.advert.title
      this.description = this.advert.description
      this.category = this.advert.category
      this.link = this.advert.link
      this.slug = this.advert.slug
      this.backgroundPreviewUrl = this.advert.background
        ? this.advert.background
        : this.backgroundPreviewUrl
      this.logoPreviewUrl = this.advert.logo
        ? this.advert.logo
        : this.logoPreviewUrl
      this.backgroundUrl = this.advert.background
        ? this.advert.background
        : this.backgroundPreviewUrl
      this.logoUrl = this.advert.logo ? this.advert.logo : this.logoPreviewUrl
    }
  },
  watch: {
    advert: function(val) {
      if (val && this.editAdvert) {
        this.link = val.link
        this.title = val.title
        this.category = val.category
        this.description = val.description
        this.connect_uid = val.connect_uid
        this.slug = val.slug
        this.displayName = val.title
        this.src = val.logo

        this.logoPreviewUrl = val.logo ? val.logo : this.logoPreviewUrl
        this.backgroundPreviewUrl = val.background
          ? val.background
          : this.backgroundPreviewUrl
        this.logoUrl = val.logo ? val.logo : this.logoPreviewUrl
        this.backgroundUrl = val.background
          ? val.background
          : this.backgroundPreviewUrl
      }
    }
  },
  components: {
    Avatar,
    CategoryOptions,
    DescriptionComponent
  },
  computed: {
    ...mapGetters(['getCategories', 'isLoggedIn', 'Uid']),
    profile() {
      return this.$store.state.auth.profile
    },

    slug: {
      get() {
        if (this.editAdvert) {
          return this.advert.slug
        } else {
          return this.title
            ? this.title
                .trim()
                .replace(/\s+/g, '-')
                .replace(/'/g, '')
                .replace(/^-+|-+$/g, '')
                .toLowerCase()
            : null
        }
      },
      set(value) {
        this.slugValue = value
      }
    },
    checkSlug() {
      return this.businessNameMatch ? 'Slug already exists!' : true
    },
    categoryData() {
      return this.$store.state.links.categories.category
    },
    businessName() {
      return this.title ? this.title : 'Display name'
    },
    profileCategory() {
      return this.category && this.category.length > 0
        ? this.category
        : 'Category'
    }
  },
  methods: {
    ...mapActions([
      'addAdvert',
      'updateAdvert',
      'fetchLinks',
      'fetchFavourites',
      'fetchCategories',
      'updateProfile'
    ]),
    updateDescription(newDescription) {
      this.description = newDescription
    },
    descriptionIsValid(val) {
      this.isValidDescription = val
      return val
    },
    modifyCategory(val) {
      this.category = val
    },
    getAdvert() {
      this.uid
        ? advertisers
            .where('user_id', '==', this.uid)
            .where('status', '==', true)
            .get()
            .then(snapshot => {
              snapshot.forEach(doc => {
                this.advert = doc.data()
              })
            })
        : null
    },
    async checkDuplicate() {
      const check = await advertisers
        .where('slug', '==', this.slug)
        .get()
        .then(snapshot => {
          if (this.editAdvert) {
            this.businessNameMatch = false
            return false
          }
          if (snapshot.empty) {
            this.businessNameMatch = false
            return false
          } else {
            this.businessNameMatch = true
            return true
          }
        })
      return check
    },
    onLogoFile(event) {
      if (event) {
        let filename = event.name
        this.logoFilename = filename
        // set previewUrl image
        if (filename.lastIndexOf('.') <= 0) {
          return
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.logoPreviewUrl = fileReader.result

          this.uploadImage(
            filename,
            fileReader.result,
            'advertisers/starter/logo',
            'logo'
          )
        })
        fileReader.readAsDataURL(event)
      } else {
        this.logoPreviewUrl = this.logoPlaceholder
      }
    },
    onBackgroundFile(event) {
      if (event) {
        let filename = event.name
        this.backgroundFilename = filename
        // set backgroundUrl image
        if (filename.lastIndexOf('.') <= 0) {
          return
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.backgroundPreviewUrl = fileReader.result

          this.uploadImage(
            filename,
            fileReader.result,
            'advertisers/starter/background',
            'background'
          )
        })
        fileReader.readAsDataURL(event)
      } else {
        this.backgroundPreviewUrl = this.backgroundPlaceholder
      }
    },
    async uploadImage(filename, base64Str, path, type) {
      let submitBase64Str = base64Str.split(',')[1]
      try {
        var metaData = {
          contentType: 'image/png'
        }
        const storageRef = firebase.storage().ref()
        const imageRef = storageRef.child(`${path}/${this.uid}/${filename}`)
        await imageRef.putString(submitBase64Str, 'base64', metaData)
        const downloadUrl = await imageRef.getDownloadURL()

        if (type === 'logo') {
          this.logoUrl = downloadUrl
        } else {
          this.backgroundUrl = downloadUrl
        }
      } catch (error) {
        console.log(error)
      }
    },

    async onPaste() {
      const pasteText = await navigator.clipboard.readText()
      this.link = pasteText
    },

    addProtocol() {
      if (!this.$route.query['url']) {
        this.link = 'https://www.'
      }
    },

    closeModal(data) {
      this.$refs.form.reset()
      this.$emit('modalClose', data)
    },

    submit() {
      if (this.$refs.form.validate() && this.isValidDescription) {
        let user = firebase.auth().currentUser
        if (user) {
          let extractDomain = api.extractDomain(this.link)

          let value = {
            title: this.title,
            description: this.description,
            domain: extractDomain,
            link: this.link,
            slug: this.slugValue || this.slug,
            category: this.category,
            categoryTitle: this.category,
            logo: this.logoUrl,
            background: this.backgroundUrl
          }

          if (this.editAdvert) {
            value = {
              ...value,
              doc_id: this.advert.doc_id,
              updated: firebase.firestore.Timestamp.now()
            }
            this.updateAdvert(value).then(() => {
              this.$notify({
                type: 'success',
                group: 'action',
                title: 'Advert Updated',
                text: `${this.title} in ${this.category} has been updated!`
              })
              //this.closeModal({ success: true })
            })
          } else {
            // set values for created
            value = {
              ...value,
              created: firebase.firestore.Timestamp.now(),
              user_id: user.uid,
              status: false
            }

            // Assign profile to an avertiser account.
            api.profileUpdate({
              advertiser: false
            })

            this.addAdvert(value).then(() => {
              this.$notify({
                type: 'success',
                group: 'action',
                title: 'Advert Added',
                text: `${this.title} in ${this.category} has been created!`
              })
              this.closeModal({ success: true })
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// White background for the entire dialog container
.advert-modal-container {
  background-color: #ffffff !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.advert-modal-container .v-container {
  background-color: #ffffff !important;
}

.advert-modal-container .v-card-actions {
  background-color: #ffffff !important;
}

.advert-modal-container .v-card {
  background-color: #ffffff !important;
}

.dropzone {
  padding: 0;
  min-height: 0;
  height: auto;

  .dz-message {
    margin: auto;
  }
}
.img-div {
  display: flex;
  margin: 25px;
  border-radius: 50%;
}

// Ensure form container properly contains all fields
.form-row {
  width: 100%;

  .v-col {
    width: 100%;
    max-width: 100%;
  }

  .v-form {
    width: 100%;
  }

  .v-form .v-row {
    width: 100%;
    margin: 0;
  }
}

// Mobile responsive styles
@media (max-width: 600px) {
  .v-container {
    padding: 8px !important;
  }

  .v-card {
    margin: 0 !important;
  }

  .preview-card {
    height: auto !important;
    min-height: 120px;
  }

  .preview-overlay {
    margin: 0 !important;
    position: absolute;
    top: 70px;
    width: 100%;
  }

  .preview-overlay .v-list-item {
    padding: 4px 8px;
  }

  .preview-overlay .v-list-item-content {
    margin-left: 8px !important;
  }

  .preview-overlay .title {
    font-size: 0.875rem !important;
  }

  .form-row {
    margin: 8px 0 !important;
  }

  .v-card__actions {
    flex-direction: column;
    padding: 8px !important;
  }

  .v-btn {
    width: 100%;
    margin: 4px 0 !important;
  }

  // Ensure nested containers don't add extra padding
  .v-container .v-container {
    padding: 0 !important;
  }

  // Remove extra padding from form fields
  .v-text-field,
  .v-file-input,
  .v-select {
    margin-bottom: 0 !important;
  }

  // Description component mobile styling
  .description-wrapper {
    margin: 0 !important;
    padding: 0 !important;
  }

  .my-custom-editor {
    margin: 0 !important;
    padding: 0 !important;
  }

  // Remove extra margins from form rows
  .form-row .v-row {
    margin: 0 !important;
  }

  .form-row .v-col {
    padding: 8px 12px !important;
  }
}
</style>
